<template>
  <div class="row p-list-representation-wrapper align-items-start w-100">
    <div class="row w-100 p-list-representation-province-main pr-4 pl-4">

      <div class="w-100 d-flex flex-wrap p-list-representation-province-data-item mt-4 mb-4">
        <cityAndProvince
        @selectedCity      = "selectedCity"
        @selectedProvince  = "selectedProvince"

        :update-city-selected="updateCitySelected"
        :citys             ="citys"
        :province-items    ="provinceItems"
        :city-selected     ="citySelected"
        :province-selected ="provinceSelected"
        ></cityAndProvince>
      </div>

      <div class=" d-flex flex-wrap p-list-representation-province-data-item w-100">
        <div class="row w-100 flex-column flex-lg-row">
          <fromData
          @entryPaySalons="entryPaySalons"
          :excel-data="excelData"
          :original-form-data="formData"
          @searchData="searchData"

          ></fromData>
        </div>
      </div>

    </div>

    <modalSelectFile :active.sync="statusShowModalSelectFile" @submitModalFile="submitModalFile"  />
    <modalEntry :active.sync="statusEntryPay" @closeModalEntry="closeModalEntry" />
  </div>
</template>

<script>
import cityAndProvince from './cityAndProvince';
import fromData from './fromData';
import modalSelectFile from './modalSelectFile';
import modalEntry from './modalEntry';


export default {
  name: "listRepresentation",
  components: {
    cityAndProvince,
    fromData,
    modalSelectFile,
    modalEntry,
  },

  props: {
    citys                        : {type:Array,default:[]},
    provinceItems                : {type:Array,default:[]},
    excelData                    : {type:Array,default:[]},
    citySelected                 : {type:Object,default:{}},
    provinceSelected             : {type:Object,default:{}},
    statusShowModalEntryPay      : {type:Boolean,default:false},
    formData                     : {type:[Array,Object],default:{}},
    updateCitySelected           : {type:Number,default:0},


  },

  data() {
    return {
      statusShowModalSelectFile   : false,
      statusEntryPay              : false,
    }
  },

  watch: {
    statusShowModalEntryPay(status){
      this.statusEntryPay = status;
    }

  },

  created() {

  },

  mounted() {
  },

  methods: {
    submitTransactionExcel(blob){
      console.log(blob,'selectedFileActive');
    },


    selectedCity(data){
      this.$emit('selectedCity',data);
    },

    selectedProvince(data){
      this.$emit('selectedProvince',data);
    },


    entryPaySalons(){
      this.statusShowModalSelectFile = true;
    },

    submitModalFile(data){
      console.log('submitModalFile',data);
    },

    closeModalEntry(status){
      this.$emit("closeModalEntry",status)
    },

    searchData(data){
      this.$emit('searchData',data)
    }




  }


}
</script>
